import type { AddNeedResourceDetailsToActionRequest } from '@act/shared/types';
import { formatSingleResourceReferral } from 'react-components/forms/cboResourceForm/formatSingleResourceReferral.util';
import type { ActionFormResourceDetails } from '../components/useNeedActionFormtypes';

export type ResourceDetailsRequestWithId = AddNeedResourceDetailsToActionRequest & {
  id: number;
};

/**
 * Maps resource referral form rows to the API request shape, including phone formatting.
 *
 * @param resourceRequests - Form rows with optional persisted ids.
 * @returns Payload for need action resource referrals.
 */
export function formatNeedActionResourceReferrals(
  resourceRequests: ResourceDetailsRequestWithId[]
): AddNeedResourceDetailsToActionRequest[] {
  return resourceRequests.map(details =>
    formatSingleResourceReferral(details as ActionFormResourceDetails)
  );
}
